<template>
  <v-dialog
    v-model="billModal"
    @click:outside="closeDialog"
    scrollable
    max-width="650px"
  >
    <v-card flat v-if="!saved">
      <v-card-title>
        <span class="headline">{{ billPaymentStatus.name }}</span>
        <v-spacer></v-spacer>
        <v-chip
          v-if="billPaymentStatus.type == 'pendiente'"
          large
          color="red"
          dark
          class="pr-5 text-h4"
        >
          <v-avatar right>
            <v-icon>mdi-currency-usd</v-icon>
          </v-avatar>
          {{ billSum }}
        </v-chip>
        <PaymentMethodSelector v-else @selectionChanged="setPaymentMethod" />
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <template v-if="billPaymentStatus.type == 'cobrar'">
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="abono"
                @keyup="abonar"
                outlined
                prefix="$"
                autofocus
                hide-details
                placeholder="0"
                color="cyan"
                label="Monto Recibido*"
                class="text-h5 font-weight-black"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                hide-details
                filled
                shaped
                disabled
                prefix="$"
                v-model="cambio"
                label="CAMBIO*"
                class="text-h5 font-weight-bold"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-chip large color="red" dark class="pr-5 text-h4">
                <span class="text-caption">Total</span>
                <v-avatar right>
                  <v-icon>mdi-currency-usd</v-icon>
                </v-avatar>
                {{ billSum }}
              </v-chip>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                filled
                hide-details
                shaped
                disabled
                prefix="$"
                v-model="computedSaldo"
                label="Saldo*"
                class="text-h5 font-weight-bold"
              ></v-text-field>
            </v-col>
          </template>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="500px"
              min-width="350px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="humanFechaEntrega"
                  label="Fecha de entrega"
                  hint="día mes, año"
                  persistent-hint
                  prepend-icon="mdi-calendar-clock"
                  v-bind="attrs"
                  v-on="on"
                  @change="setDateFromField($event)"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <div class="tmp-box">
              <v-time-picker
                v-model="time"
                :landscape="$vuetify.breakpoint.mdAndUp"
                format="ampm"
                :min="horarioApertura"
                :max="horarioCierre"
                color="cyan"
                width="300px"
                type="month"
                scrollable
              ></v-time-picker>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" @click="closeDialog">Cancelar</v-btn>
        <v-hover v-slot="{ hover }">
          <v-card flat>
            <v-alert
              v-if="hover && billPaymentStatus.type == 'cobrar' && abono <= 0"
              outlined
              type="error"
              border="left"
              dense
              class="ml-2 mb-0"
            >
              Introducir monto de <strong>pago</strong>
            </v-alert>
            <v-btn
              v-else
              :color="
                billPaymentStatus.type == 'cobrar' && abono <= 0
                  ? ''
                  : 'cyan darken-1'
              "
              :dark="
                (billPaymentStatus.type == 'cobrar' && abono > 0) ||
                billPaymentStatus.type == 'pendiente'
              "
              class="ml-5"
              :key="buttonKey"
              :disabled="!abono && billPaymentStatus.type == 'cobrar'"
              @click.once="save"
              >Guardar Venta</v-btn
            >
          </v-card>
        </v-hover>
      </v-card-actions>
    </v-card>
    <v-card color="success" v-if="saved" height="100%">
      <v-alert type="success" prominent border="left">
        <span class="ml-3">Venta guardada correctamente!</span>
      </v-alert>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog">Ok</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import printTicketMixin from "../../mixins/mixin-print-ticket.js";
import cobrarMixin from "../../mixins/mixin-cobrar.js";
import uiMixin from "../../mixins/mixin-ui.js";

import {
  formatDecimal,
  createNewDateString,
  formatDateForHumans,
  getCurrentTime,
  humanDateFormat
} from "../../services/utils";

import PaymentMethodSelector from "../PaymentMethodSelector.vue";
//placed in the window object by the preload and available in the global context
// const { lastInsertedSalesFolio } = api.services.ventasService;
// const { saveNew, makeNewBillCode, getSaleByCodigo } =
//   api.services.ventasService;
// const { updateClientVisitsByID } = api.services.clientesService;
// const { registrarCobro, realizarAutoRetiro } = api.services.cajaService;
// const { getCategoriaByID } = api.services.categoriasService;
// const { addNewServicioPendiente } = api.services.pendientesService;
// const { getLaundryInfo } = api.services.settingsService;


const ADELANTO = "Adelanto a Cuenta";
const PAGO = "Pago Adelantado";

export default {
  name: "SaveNewBillModal",
  mixins: [printTicketMixin, cobrarMixin, uiMixin],
  components: { PaymentMethodSelector },
  data: function () {
    return {
      pagoTarjeta: false,
      saved: false,
      dateMenu: false,
      time: getCurrentTime(),
      cliente: "",
      date: new Date().toISOString().substr(0, 10),
      abono: null,
      saldo: 0,
      cambio: formatDecimal(
        this.abono > this.billSum ? this.abono - this.billSum : 0
      ),
      laundryData: null,
    };
  },
  computed: {
    ...mapGetters([
      "billModal",
      "billIsValid",
      "billClientData",
      "billPaymentStatus",
      "billSum",
      "billItems",
      "user",
      'demoLaundryInfo',
      'demoCategorias',
      'getDemoSaleByCodigo',
      'lastInsertedDemoSalesFolio',
      'demoUser'
    ]),
    horarioApertura() {
      const { horaApertura } = JSON.parse(this.laundryData.value);
      return horaApertura;
    },
    horarioCierre() {
      const { horaCierre } = JSON.parse(this.laundryData.value);
      return horaCierre;
    },
    horaEntrega() {
      return this.time;
    },
    fechaEntrega() {
      return this.date;
    },
    humanFechaEntrega() {
      return this.date ? formatDateForHumans(this.date) : "";
    },
    computedSaldo: {
      get: function () {
        return formatDecimal(this.saldoCalc());
      },
      set: function (newSaldo) {
        this.saldo = newSaldo;
      },
    },
  },
  methods: {
    ...mapActions([
      "clearBillItems",
      "clearBillClient",
      "requestNewFolio",
      "resetBillPaymentStatus",
      'saveNewDemoSale',
    ]),
    lastInsertedSalesFolio(){ return this.lastInsertedDemoSalesFolio; },
    saveNew(billData){
      const newFolio = this.lastInsertedSalesFolio() +1;
      const cliente = this.billClientData;
      const vendedor = this.demoUser;
      const humanFechaRecepcion = humanDateFormat(billData.fecha_recepcion, 'es');
      const humanFechaEntrega = humanDateFormat(billData.fecha_entrega, 'es');
      // console.log("[newFolio] ",newFolio);
      this.saveNewDemoSale({
        ...billData, 
        id:newFolio,
        nombreCliente: `${cliente.nombre} ${cliente.apellido}`,
        nombreVendedor: `${vendedor.nombre}`,
        humanFechaEntrega,
        humanFechaRecepcion 
      });
    },
    makeNewBillCode(){
      return new Promise((resolve, reject)=>{
        resolve(Math.floor(Math.random()*10000))
        reject("Error")
      });
    },
    getSaleByCodigo(codigo){
      const sale = this.getDemoSaleByCodigo(codigo);
      // console.log("[sale] ", sale);
      return sale;
    },
    updateClientVisitsByID(){},
    registrarCobro(){},
    realizarAutoRetiro(){},
    getCategoriaByID(id){
      // console.log("[updateClientVisitsByID|id] ", id);
      const categorias = this.demoCategorias;
      return categorias.find(category => category.id = id);
    },
    addNewServicioPendiente(folioID, idCliente, idUsuario){
      console.log("[addNewServicioPendiente| (folioID, idCliente, idUsuario)] ", folioID, idCliente, idUsuario);
    },
    getLaundryInfo(){ 
      const info = this.demoLaundryInfo;
      return info; 
    },
    save() {
      const self = this;
      this.makeNewBillCode().then((codigo) => {
        // console.log("[codigo] ",codigo);
        const billData = self.makeBillDataPayload(codigo);
        // console.log("[billData] ",billData);
        this.saveNew(billData);
        this.updateClientVisitsByID(billData.id_cliente);

        this.saved = true;
        //Caja record logic and operations here
        const abono = parseFloat(billData.abono);
        const total = parseFloat(this.billSum);
        const folio = this.getSaleByCodigo(billData.codigo);
        // console.log("[folio] ",folio);
        const idUsuario = this.user.id;
        const idCliente = billData.id_cliente;
        if (abono > 0) {
          const monto = abono >= total ? total : abono;
          const cobro = {
            folio: folio.id,
            monto: monto.toFixed(2),
            saldo: billData.saldo,
            denominacion: billData.denominacion,
            concepto: billData.saldo == 0 ? PAGO : ADELANTO,
            id_usuario: idUsuario,
            co_responsable: idCliente,
          };
          const cobroResponse = this.registrarCobro(cobro);
          console.log("[cobroResponse] ",cobroResponse);
          if (this.formaPago.code !== "efectivo") {
            const concepto = this.formaPago.code;
            const retiroResponse = this.realizarAutoRetiro(
              "retiro",
              folio.id,
              monto,
              concepto,
              idUsuario
            );
            console.log("[retiroResponse] ",retiroResponse);
          }
        }
        this.addNewServicioPendiente(folio.id, idCliente, idUsuario);
        setTimeout(function () {
          // self.printBillTicket(codigo, "NEW_BILL");
          self.resetBill();
          self.closeDialog();
          self.saved = false;
          self.resetButtonClickState(); //from uimixin
        }, 1000);
      });
    },

    abonar() {
      this.saldo = this.saldoCalc();
      this.cambio = this.cambioCalc();
    },
    saldoCalc() {
      const abono = Number(this.abono);
      const total = Number(this.billSum);
      return abono < total ? total - abono : 0;
    },
    cambioCalc() {
      const abono = Number(this.abono);
      const total = Number(this.billSum);
      return formatDecimal(abono > total ? abono - total : 0);
    },
    // setDateFromField(date){
    //TODO: handle when the user inuts the date by typing it
    // console.log("[date from text field] ", date);
    // },
    makeBillDataPayload(codigo) {
      const productos = this.billItems.filter((item) => {
        // console.log("[item] ", item);
        const categoria = this.getCategoriaByID(item.id_categoria);
        return (
          item.id_categoria === categoria.id && categoria.tipo === "productos"
        );
      });
      const servicios = this.billItems.filter((item) => {
        const categoria = this.getCategoriaByID(item.id_categoria);
        return (
          item.id_categoria === categoria.id && categoria.tipo === "servicios"
        );
      });
      const cliente = this.billClientData;
      const total = parseFloat(this.billSum).toFixed(2);
      const saldo = this.computedSaldo; //this.billSum - this.abono;
      const abono = this.abono
        ? parseFloat(this.abono) <= total
          ? parseFloat(this.abono).toFixed(2)
          : total
        : 0;
      const statusPago =
        this.billPaymentStatus.type === "cobrar" && saldo <= 0
          ? "pagado"
          : this.billPaymentStatus.type === "cobrar" && saldo > 0
          ? "saldo pendiente"
          : "por cobrar";
      const formaPago = this.formaPago.name;

      const payload = {
        codigo,
        id_cliente: cliente.id,
        id_vendedor: this.user.id,
        servicios: JSON.stringify(servicios),
        productos: JSON.stringify(productos),
        impuesto: 0,
        neto: total,
        total: total,
        abono: abono,
        saldo: saldo,
        denominacion: this.abono ? this.abono : 0,
        metodo_pago:
          this.billPaymentStatus.type === "pendiente" ? "Pendiente" : formaPago,
        status_er: "recibida",
        status_pago: statusPago,
        fecha_recepcion: createNewDateString(),
        fecha_entrega: `${this.date} ${this.time}`,
      };
      return payload;
    },
    resetBill() {
      this.clearBillItems();
      this.clearBillClient();
      this.resetBillPaymentStatus();
      this.requestNewFolio(this.lastInsertedSalesFolio() + 1);
      this.total = 0;
      this.abono = 0;
      this.saldo = 0;
      this.cambio = 0;
      this.cliente = "";
      this.date = new Date().toISOString().substr(0, 10);
      this.time = getCurrentTime();
      this.dateMenu = false;
      this.formaPago = "";
    },
    closeDialog() {
      this.saved = false;
      this.$emit("close");
    },
  },
  beforeMount() {
    this.saldo = this.billSum;
    this.laundryData = this.getLaundryInfo();
  },
};
</script>

<style lang="scss" scoped>
.tmp-box {
  display: flex;
  justify-content: center;
  max-height: 300px;
}
</style>